import BaseService from '@src/services/BaseService'

class ExportPresentationJobConfigService extends BaseService {
    constructor() {
        super('export-presentation-job-configs')
    }
}

export default new ExportPresentationJobConfigService()
